// Inbox actions shared by the list ("Take") and the empty pane ("Take next").

// Assign to me with the same actions as "Assign to me" in the conversation (ActionsRectangle), then open it
// in "My chats".
export const takeConversation = (conversation, {assignToMe, setAssigned, setChatId, setTabId}) => {
    assignToMe(conversation._id);
    setAssigned();
    setTabId('1');
    setChatId(conversation._id);
};

// Keyboard shortcuts stay out of fields, the composer and open dialogs.
export const isEditableTarget = target => {
    if (!target) return false;
    const tag = (target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select' || target.isContentEditable) return true;
    return !!(target.closest && target.closest('.ant-modal, .ant-select-dropdown, .ant-drawer, [role="dialog"]'));
};
